import { PictureModel } from "./picture.model";

export class SlideShowModel {
    public title: string;
    public description: string;
    public pictures: PictureModel[] = [];
    public types: string[] = [];
}


// WEBPACK FOOTER //
// ./src/app/models/slideshow.model.ts